export const SET_SHOW = "set_show";
export const SET_SHOW_COOKIE = "set_show_cookie"
